export const isWhiteLabel = (state) => {
  return state.plan.group === 'white-label'
}
